import template from './timeSelectFormElement.html';
import controller from './timeSelectFormElement.controller';
import './timeSelectFormElement.scss';

let timeSelectFormElementComponent = {
  restrict: 'E',
  bindings: {
    value: '=',
    label: '@'
  },
  template,
  controller
};

export default timeSelectFormElementComponent;
